module.exports = __webpack_public_path__ + "static/media/Panel-Business-Card.ecaed60b.svg";